/* eslint-disable camelcase */
import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import styled from 'styled-components';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { Restaurant, ChangeToSlug } from '../../utils';
import { ReactComponent as LocationIcon } from '../../../../svg/icon_location.svg';

interface Props extends Restaurant {}

const MaxLine3 = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
const MaxLine1 = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
const MaxLine2 = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: 345,
    },
    media: {
      height: 0,
      paddingTop: '56.25%', // 16:9
    },
    expand: {
      transform: 'rotate(0deg)',
      marginLeft: 'auto',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest,
      }),
    },
    desc: {
      display: '-webkit-box',
      webkitLineClamp: 3,
      webkitBoxOrient: 'vertical',
      overflow: 'hidden',
    },
  }),
);
const Item: React.FC<Props> = (props) => {
  const { present_image, name, id, short_desc, location } = props;
  const classes = useStyles();
  return (
    <Link to={`/detailRestaurant/${ChangeToSlug(name, id)}`}>
      <Card style={{ borderRadius: '6pt', boxShadow: 'none' }}>
        <CardMedia
          className={classes.media}
          image={
            present_image ||
            'https://storage.googleapis.com/vntravel-fe/325d6c01f699ef48bfc42ad9f3b253cd/81f23f4307a6d6485035f80996b4a630/ad9cc2e15feea17a14b16dc351f7e434.png'
          }
          title={name}
        />
        <CardContent>
          <MaxLine2>
            <Typography style={{ fontSize: 16, lineHeight: '20pt' }} variant="h5">
              {name}
            </Typography>
          </MaxLine2>
          <MaxLine1>
            <Typography variant="body1" style={{ color: 'rgb(119,119,119)', fontSize: '14px' }}>
              <LocationIcon style={{ display: 'inline-block', marginRight: 10 }} />
              {location}
            </Typography>
          </MaxLine1>
          <MaxLine3>
            <Typography
              variant="body1"
              style={{ color: 'rgb(51,51,51)', fontSize: '14px', marginTop: 10 }}
            >
              {short_desc}
            </Typography>
          </MaxLine3>
        </CardContent>
      </Card>
    </Link>
  );
};

export default Item;
